import Swal from "sweetalert2";
import AuthHelpers from "@/helpers/authHelpers";
import NavigationHelpers from "@/helpers/navigationHelpers";
import BarrierControl from "@/helpers/barrierControl";

// Exponer Swal globalmente para scripts inline (ej: aside)
window.Swal = Swal;

const index = () => {
    // Redirige al login si no hay sesión activa
    // const protectPage = async () => {
    //     const isAuth = await AuthHelpers.isAuthenticated();
    //     if (!isAuth) {
    //         window.location.href = '/login';
    //     }
    // };

    // Maneja el evento de logout
    const setupLogout = () => {
        const logoutBtn = document.getElementById('logoutBtn');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', async () => {
                await AuthHelpers.logout();
            });
        }
    };

    const getYearForFooter = () => {
        const yearContainer = document.querySelector('.yearContainer')
        const date = new Date()
        console.log(date.getFullYear())

        yearContainer.textContent = date.getFullYear()
        
    }

    return {
        init: () => {
            // protectPage();   // Primero protegemos la vista
            setupLogout();   // Luego activamos el botón
            NavigationHelpers.init(); // Inicializa navegación
            BarrierControl.init(); // Inicializa control de barrera
            getYearForFooter();
        }
    };
};

document.addEventListener('DOMContentLoaded', () => {
    index().init();
});
